<script>
	import { onMount } from "svelte";
	import { uiText } from "../lib/uiText.js";
	export let lang = "bg";
	export let sessionData;
	export let taskData;

	console.log(taskData);

	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));

	let now = Date.now();
	let interval;

	// Update 'now' continuously while the component is mounted
	onMount(() => {
		interval = setInterval(() => {
			now = Date.now();
		}, 250); // 10ms for smooth millisecond updates

		return () => clearInterval(interval);
	});

	// Reactive statement to calculate total elapsed milliseconds
	$: elapsedMs = Math.max(
		0,
		now - new Date(sessionData.session.sessionStart.toDate()).getTime(),
	);

	// Helper function to format milliseconds into HH:MM:SS.mm
	function formatTime(ms) {
		const days = Math.floor(ms / 86400000);
		const hours = Math.floor((ms % 86400000) / 3600000);
		const minutes = Math.floor((ms % 3600000) / 60000);
		const seconds = Math.floor((ms % 60000) / 1000);
		const milliseconds = Math.floor((ms % 1000) / 10); // 2 digits

		const pad = (num) => String(num).padStart(2, "0");

		return days > 0
			? days == 1
				? `${pad(days)} ${ui.global.time.day_long}, ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
				: `${pad(days)} ${ui.global.time.days_long}, ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
			: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
		// .${pad(milliseconds)}
	}
</script>

<div class="timer-container grid text-center self-start">
	{@html taskData?.timerStyling || ""}
	<h3 class="clock-title">
		{#if lang === "bg"}
			Изминало време:
		{:else}
			Elapsed Time:
		{/if}
	</h3>
	<span class="clock">{formatTime(elapsedMs)}</span>
</div>

<style>
	.timer-container {
		font-family: monospace;
		font-size: 1.2rem;
	}
	.clock {
		font-weight: bold;
	}
</style>
